import { readDate, type DateOrder } from '@lineage/core';
import { useState } from 'react';
import { useT } from '../../i18n';

const today = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

/**
 * Date picker that stores "YYYY-MM-DD", or just "YYYY" when only the year is known.
 * Older free-text values we can't turn into a date are kept untouched until the person picks one.
 */
export function DateField({ label, value, onChange, min = '1000-01-01', order = 'dmy' }: { label: string; value: string; onChange: (v: string) => void; min?: string; order?: DateOrder }) {
  const t = useT().form;
  const initial = readDate(value, order);
  const [yearOnly, setYearOnly] = useState(initial.kind === 'year');
  const v = readDate(value, order);
  // Show a full-date value (including old text like "14 Mar 1952") in the picker, converted.
  const full = v.kind === 'full' ? v.iso : '';
  const year = v.kind === 'year' ? v.year : '';
  const id = `date-${label.replace(/\W/g, '').toLowerCase()}`;
  return (
    <div className="field grow">
      <label htmlFor={id} className="field-label">{label}</label>
      {yearOnly ? (
        <input id={id} className="input" type="text" inputMode="numeric" maxLength={4} placeholder={t.yearExample} value={year} onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, 4))} />
      ) : (
        <input id={id} className="input" type="date" min={min} max={today()} value={full} onChange={(e) => onChange(e.target.value)} />
      )}
      {v.kind === 'legacy' && <span className="muted" style={{ fontSize: 12 }}>{t.savedAs(v.text)}</span>}
      <label className="row" style={{ gap: 6, fontSize: 13 }}>
        <input
          type="checkbox"
          checked={yearOnly}
          onChange={(e) => {
            setYearOnly(e.target.checked);
            // carry the year across when switching modes
            const y = v.kind === 'full' ? v.iso.slice(0, 4) : v.kind === 'year' ? v.year : '';
            if (v.kind !== 'legacy') onChange(e.target.checked ? y : v.kind === 'year' ? '' : value);
          }}
        />
        {t.onlyYear}
      </label>
    </div>
  );
}
